export default () => Boolean(typeof window === 'undefined')
